import CustomTooltip from '@/components/tooltips/CustomTooltip';
import useClickOutside from '@/hooks/useClickOutside';
import { Button } from '@acast-tech/decibel';
import { ArrowDownToLineLightGlyph } from '@acast-tech/decibel-glyphs';
import { useState } from 'react';

const AudienceDownloadTrigger = () => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const popoverRef = useClickOutside<HTMLDivElement>(() => setIsTooltipOpen(false), {
    excludeSelector: 'a',
  });
  return (
    <div ref={popoverRef}>
      <Button
        size="large"
        variant="primary"
        type="button"
        disabled
        glyph={ArrowDownToLineLightGlyph}
        onMouseOver={() => setIsTooltipOpen(true)}
        onMouseLeave={() => setIsTooltipOpen(false)}
      >
        Download
      </Button>
      <CustomTooltip
        popoverRef={popoverRef}
        placement="bottom"
        isOpen={isTooltipOpen}
        zIndex={50}
        className="bg-[#FAFAFA] text-DarkGrey shadow-lg min-w-[200px] right-[-3.5rem]"
      >
        <div className="flex flex-col">
          <b className="mb-2 text-sm font-medium">Coming soon</b>
          <p className="text-sm">We are working on this at the moment.</p>
        </div>
      </CustomTooltip>
    </div>
  );
};

export default AudienceDownloadTrigger;
